import { render, staticRenderFns } from "./EditInfo.vue?vue&type=template&id=1a727aa1&scoped=true&"
import script from "./EditInfo.vue?vue&type=script&lang=js&"
export * from "./EditInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditInfo.vue?vue&type=style&index=0&id=1a727aa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a727aa1",
  null
  
)

export default component.exports